import { getStoredValueReward, RewardApprovalBody } from 'src/common/helpers/transaction-helper';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import {
  getMonetaryStoredValuePromotions,
  handleRewardPostErrors,
} from './get-monetary-stored-value-promotions';

export const msvCheck = async (cartResponse: CartResponse) => {
  const msvCheck = await getStoredValueReward().catch(() => {});
  // Do we have a true and false msv reward for the same program + promotion
  let matchingMSVRewards = false;

  if (!!msvCheck && msvCheck.totalResults >= 1) {
    const tempArr: RewardApprovalBody[] = [];
    // Loop over all retrieved MSV rewards
    msvCheck.pageContent.forEach(msvEntry => {
      // If the array is empty, push the first element
      if (tempArr.length === 0) {
        tempArr.push(msvEntry.redeemLoyalty);
      } else {
        // Check the first element of the array with the current msv reward.  If they match and have opposing approved flags, then pop the array
        const top = tempArr[0];
        if (
          top.promotionId === msvEntry.redeemLoyalty.promotionId &&
          top.programId === msvEntry.redeemLoyalty.programId &&
          top.approved === !msvEntry.redeemLoyalty.approved
        ) {
          tempArr.pop();
        } else {
          tempArr.push(msvEntry.redeemLoyalty);
        }
      }
    });
    // If the array has data, that means the user has redeem an award, so they shouldn't see the redemption page again.
    if (tempArr.length === 0) {
      matchingMSVRewards = true;
    }
  }
  if ((!!msvCheck && msvCheck.totalResults === 0) || matchingMSVRewards) {
    await getMonetaryStoredValuePromotions(cartResponse.rewards || []).catch(
      handleRewardPostErrors,
    );
  }
};
